import { h } from 'preact'
import { EsiInclude } from '../../esi-include/esi-include.tsx'
import styles from './spesialmodul.module.css'

export const Spesialmodul = ({ id, width }) => {
  const className =
    width === 'Fullbredde'
      ? `${styles.spesial} breakingmal-fullbredde dh-fullbredde`
      : styles.spesial
  return <EsiInclude className={className} id={id} />
}
